<template>
  <div class="col-sm-12 routa-dark">
  <b-row class="text-center">
    <b-col>
      <span class="footer-text">Copyright © Routa Systems Oy 2022</span>
      <span class="footer-text privacy-link" @click="$bvModal.show('bv-modal-privacy')">{{ $t('privacy.title') }}</span>
    </b-col>
    <b-col>
      <span class="footer-text">Routa Systems Oy (osa Sitowise Oy:tä)</span>
      <span class="footer-text">Linnoitustie 6D</span>
      <span class="footer-text">FI-02600 Espoo</span>
      <span class="footer-text">Finland</span>
      <span class="footer-text">{{ $t('contact.business_id') }}: 3019045-8</span>
    </b-col>
  </b-row>
  <b-modal id="bv-modal-privacy" hide-footer>
    <template slot="modal-title">
      {{ $t('privacy.title' )}}
    </template>
    <span class="routa-privacy">{{ $t('privacy.intro')}}</span>
    <div class="d-block">
      <span class="routa-privacy-title blue">{{$t('privacy.subtitle_what')}}</span>
      <p class="routa-privacy">{{ $t('privacy.what_descr')}}</p>
    </div>
    <div class="d-block">
      <span class="routa-privacy-title blue">{{$t('privacy.subtitle_why')}}</span>
      <p class="routa-privacy">{{ $t('privacy.why_descr')}}</p>
    </div>
    <div class="d-block">
      <span class="routa-privacy-title blue">{{$t('privacy.subtitle_where')}}</span>
      <p class="routa-privacy">{{ $t('privacy.where_descr')}}</p>
    </div>
    <div class="d-block">
      <span class="routa-privacy-title blue">{{$t('privacy.subtitle_how_long')}}</span>
      <p class="routa-privacy">{{ $t('privacy.how_long_descr')}}</p>
    </div>
    <div class="d-block">
      <span class="routa-privacy-title blue">{{$t('privacy.right_for_info')}}</span>
      <p class="routa-privacy">{{ $t('privacy.right_for_info_descr')}}</p>
      <p class="routa-privacy">{{ $t('privacy.right_to_be_forgotten')}}</p>
    </div>
    <div class="d-block">
      <span class="routa-privacy-title blue">{{$t('privacy.subtitle_secure')}}</span>
      <p class="routa-privacy">{{ $t('privacy.secure_descr')}}</p>
    </div>
    <div class="d-block">
      <p class="routa-privacy">{{ $t('privacy.contact')}}</p>
    </div>
    <b-button class="mt-3" variant="primary" block @click="$bvModal.hide('bv-modal-privacy')">Ok</b-button>
  </b-modal>
  </div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

